// src/components/Stripsection.js
import React, { useState } from "react";
import { Modal, Button, Container, Row, Col } from "react-bootstrap";
import { BsTelephone, BsCameraVideo } from "react-icons/bs";

function Stripsection() {
    const [isOpen, setIsOpen] = useState(false);


    return (
        <section className="stripsections">
            <div className="container" id="stripsection">
                <div className="row">
                    <div className="col-xlg-4 col-lg-4"></div>
                    <div className="col-xlg-8 col-lg-8">
                        <div className="stripsections-content">
                            <h2 className="text-white mb-3">
                                Tele Medicine and Online Consulting
                            </h2>
                            <h4 className="text-white mb-3">
                                Time: Mon to Saturday 11:00 A.M to 1:00 P.M
                            </h4>

                            <button className="join-now-btn" onClick={() => setIsOpen(true)}>Join Now</button>

                            <Modal show={isOpen} onHide={() => setIsOpen(false)} centered size="lg">
                                <div className="doctor-modal">
                                    {/* Left section */}
                                    <div className="left-section">
                                        <div className="teal-top">
                                            <h2>Let's talk</h2>
                                            <span className="circle small"></span>
                                            <span className="circle medium"></span>
                                            <span className="circle large"></span>
                                        </div>

                                        <div className="white-bottom">
                                            <h2>Dr.Mahadevan.G.R</h2>
                                            <p>MBBS, MD (General Medicine), IDCCM  (Indian diploma in Critical Care &amp; Medicine)</p>
                                            <p className="phone-number">+91 9940451580 | 9940396922</p>

                                            <div className="icon-buttons">
                                              
                                              <a href="tel: +919940451580">  <button className="icon-btn">
                                                    <BsTelephone size={20} />
                                                </button></a>
                                                {/* <button className="icon-btn">
                                                    <BsCameraVideo size={20} />
                                                </button> */}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Right section */}
                                    <div className="right-sections">
                                        <img src="assets/images/doctorstrip.png" alt="Doctor" />
                                    </div>
                                </div>
                            </Modal>

                        </div>
                    </div>

                    <div className="stripsection">
                        <img
                            src="assets/images/doctorstrip.png"
                            alt="Doctor Strip"
                            className="img-fluid"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Stripsection;
